import { render } from "./ChevronIcon.vue?vue&type=template&id=c87e4f20"
const script = {}

import exportComponent from "/home/gui/adm/gpp-cmp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__